import React from 'react';


function TermBreadcrumb() {
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">Terms & Conditions</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="/" className="breadcrumb-link">Home</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
            Terms & Conditions
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default TermBreadcrumb;
